export default __webpack_public_path__ + "static/media/MeatLovers.9e92efc5.jpg";